module.exports = __webpack_public_path__ + "img/mxsz-bg.f627f187.png";